import React from 'react';
import { Heading } from './Heading';

interface SectionTitleProps {
    title: string;
    icon?: React.ReactNode;
    className?: string;
}

export function SectionTitle({ title, icon, className = '' }: SectionTitleProps) {
    return (
        <div className={`w-full flex items-center justify-center gap-6 lg:gap-8 mb-8 ${className}`}>
            <div className="flex-1 h-px bg-border-default dark:bg-border-default-dark transition-colors" />
            <Heading level={2} variant="primary" className="whitespace-nowrap flex items-center gap-3">
                {icon}
                {title}
            </Heading>
            <div className="flex-1 h-px bg-border-default dark:bg-border-default-dark transition-colors" />
        </div>
    );
}
